export const SEARCH_TYPE = "searchType";
export const SEARCH_CRITERIA = "searchCriteria";
export const DOCUMENT_TYPE = "documentTypeId";

export const parkDocumentSearch = [
  { label: "Document ID", value: "parkDocumentHeaderId", operator: "EQUAL" },
];

export const postDocumentSearch = [
  {
    label: "Post Document ID",
    value: "documentNumber",
    operator: "EQUAL",
  },
];

export const searchType = [
  { label: "Invoice No.", value: "invoiceNumber", operator: "EQUAL" },
  { label: "Invoice Amount", value: "invoiceAmount", operator: "EQUAL" },
  { label: "Vendor Name", value: "vendorName", operator: "CONTAINS" },
];
